/* Light spoke calculator on rim and hub product pages, as an accordion row of sections/main-product.liquid
   (the spoke_calculator block, rendered by snippets/lux-accordions.liquid and snippets/lux-spoke-mini-body.liquid).
   This product's measurements come from the wheel data page (matched by handle); the customer
   picks the part it is laced to. Field names match the full calculator, and the numbers are
   saved under its key once the customer has touched them, so its link carries them across. */
/* Asset URLs are stamped theme-wide, so a deploy that writes several files can leave the CDN holding an old
   body under a new URL. Touching this file after such a deploy mints a fresh stamp. */
/* Stamp refresh 25 Sept 2026: the CDN must fetch this file a minute or more after it is written. */
(function () {
'use strict';
var TOL = 1, CUT_MIN = 80, CUT_MAX = 220, HOLE = 2.5;
var STORAGE = 'lux-spoke-calc-v5', PICK_CACHE = 'luxWheelData_v1';

function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
function fmt(n, dp) { return Number(n).toFixed(dp); }
function slugOf(t) {
return String(t).toLowerCase().replace(/&/g, '-').replace(/\//g, '-').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}
function warn(tag, err) { if (window.console && console.warn) console.warn('LUX spoke mini, ' + tag + ': ' + (err && err.message ? err.message : err)); }
function spokeLength(erd, pcd, d, spokes, crosses, hole) {
var R = erd / 2, r = pcd / 2;
var a = (2 * Math.PI * crosses) / (spokes / 2);
var sq = R * R + r * r + d * d - 2 * R * r * Math.cos(a);
if (sq < 0) return NaN;
return Math.sqrt(sq) - hole / 2;
}
function parseStock(root) {
var stock = { sizes: [], avail: {}, cut: [] };
function list(s) { return String(s || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean); }
var availSet = {};
list(root.dataset.stockAvail).forEach(function (v) { availSet[v.toLowerCase()] = true; });
list(root.dataset.stockSizes).forEach(function (v) {
var m = /^(\d+(?:\.\d+)?)\s*mm$/i.exec(v);
if (!m) return;
var n = Number(m[1]);
if (!(n > 0)) return;
if (stock.sizes.indexOf(n) === -1) stock.sizes.push(n);
if (availSet[v.toLowerCase()]) stock.avail[n] = true;
else if (stock.avail[n] !== true) stock.avail[n] = false;
});
stock.sizes.sort(function (a, c) { return a - c; });
stock.cut = list(root.dataset.cutValues);
return stock;
}
function snap(len, stock) {
var sizes = stock.sizes;
if (!sizes.length) {
var pick = Math.round(len);
return { state: 'buy', pick: pick, alt: null, exact: len, lo: pick, hi: pick };
}
var lo = null, hi = null, i;
for (i = 0; i < sizes.length; i++) {
if (sizes[i] <= len) lo = sizes[i];
if (sizes[i] >= len) { hi = sizes[i]; break; }
}
var cands = [];
if (lo !== null && len - lo <= TOL + 1e-9) cands.push(lo);
if (hi !== null && hi !== lo && hi - len <= TOL + 1e-9) cands.push(hi);
if (!cands.length) return { state: 'gap', pick: null, alt: null, exact: len, lo: lo, hi: hi };
cands.sort(function (a, c) {
var aa = stock.avail[a] === true ? 0 : 1, ca = stock.avail[c] === true ? 0 : 1;
if (aa !== ca) return aa - ca;
var da = Math.abs(a - len), dc = Math.abs(c - len);
if (Math.abs(da - dc) > 1e-9) return da - dc;
return a - c;
});
return { state: 'buy', pick: cands[0], alt: cands.length > 1 ? cands[1] : null, exact: len, lo: lo, hi: hi };
}

function initMini(root) {
if (!root || root.dataset.ready) return;
root.dataset.ready = '1';
var mode = root.dataset.mode === 'rim' ? 'rim' : 'hub';
var ownWord = mode, otherWord = mode === 'rim' ? 'hub' : 'rim';
var form = root.querySelector('[data-mini-form]');
var names = ['erd', 'spacing', 'pcd_d', 'pcd_nd', 'f2l_d', 'f2l_nd', 'ctf_d', 'ctf_nd', 'spokes', 'cross', 'symmetric', 'method'];
var el = {};
names.forEach(function (n) { el[n] = form.elements[n]; });
var stock = parseStock(root);
var SHOP_URL = root.dataset.shopUrl || '/collections/bmx-spokes';
var HELP = root.dataset.helpEmail || 'help@luxbmx.com';
var PICK_URL = root.dataset.pickUrl || '';
var results = { d: root.querySelector('[data-result="d"]'), nd: root.querySelector('[data-result="nd"]') };
var statusEl = root.querySelector('[data-status]');
var buyEl = root.querySelector('[data-buy-links]');
var warnEl = root.querySelector('[data-warnings]');
var ownSummary = root.querySelector('[data-own-summary]');
var ownDetails = root.querySelector('[data-own-details]');
var ownToggle = root.querySelector('[data-own-toggle]');
var otherDetails = root.querySelector('[data-other-details]');
var pickedEl = root.querySelector('[data-picked]');
var sideLabels = root.querySelectorAll('[data-side-label]');
var dirty = false, filling = false, combo = null;

function num(name) {
var v = String(el[name].value).trim().replace(',', '.');
if (v === '') return NaN;
var n = Number(v);
return isFinite(n) ? n : NaN;
}
function lengthParam(n) { return 'filter.v.option.length=' + encodeURIComponent(n + 'mm'); }
function shopUrl() {
var parts = [], seen = {};
Array.prototype.forEach.call(arguments, function (n) {
if (n === null || n === undefined || isNaN(n) || seen[n]) return;
seen[n] = true; parts.push(lengthParam(n));
});
return SHOP_URL + (parts.length ? '?' + parts.join('&') : '');
}
function cutUrl() {
if (!stock.cut.length) return SHOP_URL;
return SHOP_URL + '?' + stock.cut.map(function (v) { return 'filter.v.option.length=' + encodeURIComponent(v); }).join('&');
}
function stockWord(n) {
var a = stock.avail[n];
return a === true ? ', in stock' : (a === false ? ', out of stock at the moment' : '');
}
function sideLine(label, count, s) {
var html = '<div class="lux-mini__buy-side"><strong>' + label + '</strong> ' + fmt(s.exact, 1) + ' mm calculated. ';
if (s.state === 'buy') {
html += 'Buy <strong>' + count + ' × ' + s.pick + ' mm</strong>' + stockWord(s.pick) + '.';
if (s.alt !== null) html += ' <a href="' + shopUrl(s.alt) + '">' + s.alt + ' mm</a> also fits' + stockWord(s.alt) + '.';
html += '<br><a class="lux-mini__buy-btn" href="' + shopUrl(s.pick) + '">Shop ' + s.pick + ' mm spokes</a>';
} else {
var near = [];
if (s.lo !== null) near.push(s.lo + ' mm');
if (s.hi !== null) near.push(s.hi + ' mm');
html += 'We don’t carry that length off the shelf' + (near.length ? '. Nearest we do are ' + near.join(' and ') : '') + '.';
if (stock.cut.length && s.exact >= CUT_MIN && s.exact <= CUT_MAX) {
html += ' A cut-to-size spoke covers it.<br><a class="lux-mini__buy-btn" href="' + cutUrl() + '">Shop cut-to-size spokes</a>';
} else {
html += ' Email <a href="mailto:' + esc(HELP) + '">' + esc(HELP) + '</a> and we’ll sort it.';
}
}
return html + '</div>';
}
function readInputs() {
var symmetric = el.symmetric.checked;
var useCtf = el.method.value === 'ctf';
var v = {
erd: num('erd'), spacing: num('spacing'),
pcdD: num('pcd_d'), pcdN: symmetric ? num('pcd_d') : num('pcd_nd'),
spokes: Number(el.spokes.value), cross: Number(el.cross.value),
symmetric: symmetric, useCtf: useCtf
};
if (useCtf) {
v.ctfD = num('ctf_d');
v.ctfN = symmetric ? num('ctf_d') : num('ctf_nd');
} else {
v.ctfD = v.spacing / 2 - num('f2l_d');
v.ctfN = v.spacing / 2 - (symmetric ? num('f2l_d') : num('f2l_nd'));
}
return v;
}
function missingFor(v) {
var own = [], other = [];
var hubList = v.useCtf ? ['spacing', 'pcd_d', 'ctf_d'] : ['spacing', 'pcd_d', 'f2l_d'];
if (!v.symmetric) hubList.push('pcd_nd', v.useCtf ? 'ctf_nd' : 'f2l_nd');
var rimList = ['erd'];
var hubMissing = hubList.filter(function (k) { var n = num(k); return isNaN(n) || n <= 0; });
var rimMissing = rimList.filter(function (k) { var n = num(k); return isNaN(n) || n <= 0; });
if (mode === 'rim') { own = rimMissing; other = hubMissing; } else { own = hubMissing; other = rimMissing; }
return { own: own, other: other };
}
function renderSide(side, len) {
var box = results[side];
var buy = box.querySelector('[data-buy]');
var exact = box.querySelector('[data-exact]');
if (isNaN(len)) {
box.classList.add('is-empty'); box.classList.remove('is-ready'); box.classList.remove('is-gap');
buy.textContent = '—'; exact.textContent = '';
return null;
}
var s = snap(len, stock);
box.classList.remove('is-empty');
box.classList.toggle('is-ready', s.state === 'buy');
box.classList.toggle('is-gap', s.state !== 'buy');
if (s.state === 'buy') {
buy.textContent = s.pick;
exact.textContent = fmt(len, 1) + ' mm calculated' + (s.alt !== null ? ' · ' + s.alt + ' also fits' : '');
} else {
buy.textContent = Math.round(len);
exact.textContent = fmt(len, 1) + ' mm calculated · not a size we carry';
}
return s;
}
function update() {
var v = readInputs();
root.classList.toggle('is-symmetric', v.symmetric);
root.classList.toggle('is-mode-ctf', v.useCtf);
root.classList.toggle('is-mode-locknut', !v.useCtf);
Array.prototype.forEach.call(sideLabels, function (n) { n.textContent = v.symmetric ? 'Both sides' : 'Drive side'; });
var missing = missingFor(v);
var fatal = [], warnings = [];
var lenD = NaN, lenN = NaN;
var ready = !missing.own.length && !missing.other.length;
root.querySelectorAll('.is-invalid').forEach(function (i) { i.classList.remove('is-invalid'); });
if (ready) {
if (v.pcdD >= v.erd || v.pcdN >= v.erd) {
fatal.push('The flange diameter is bigger than the ERD. Check the rim and hub numbers are not swapped.');
} else if (v.ctfD <= 0 || v.ctfN <= 0 || v.ctfD >= v.spacing / 2 || v.ctfN >= v.spacing / 2) {
fatal.push('The flange position does not fit inside the hub spacing. Re-check those measurements.');
} else {
lenD = spokeLength(v.erd, v.pcdD, v.ctfD, v.spokes, v.cross, HOLE);
lenN = spokeLength(v.erd, v.pcdN, v.ctfN, v.spokes, v.cross, HOLE);
if (!v.symmetric && v.pcdN > v.pcdD) {
warnings.push('The non-drive side flange is bigger than the drive side one. On nearly every hub the drive side flange is the bigger of the two, so check the sides are not swapped. Left or right hand drive makes no difference: the drive side is whichever side the driver is on.');
}
}
}
var sD = renderSide('d', lenD), sN = renderSide('nd', lenN);
var half = v.spokes / 2;
if (sD && sN) {
if (sD.state === 'buy' && sN.state === 'buy') {
statusEl.textContent = sD.pick === sN.pick
? 'Both sides take the same spoke: ' + v.spokes + ' × ' + sD.pick + ' mm.'
: half + ' × ' + sD.pick + ' mm for the drive side and ' + half + ' × ' + sN.pick + ' mm for the non-drive side.';
} else {
statusEl.textContent = 'One of these is not a size we carry off the shelf. See below for your options.';
}
statusEl.classList.add('is-ready');
if (sD.state === 'buy' && sN.state === 'buy' && sD.pick === sN.pick) {
var merged = { state: 'buy', pick: sD.pick, alt: sD.alt !== null ? sD.alt : sN.alt, exact: sD.exact, lo: sD.lo, hi: sD.hi };
buyEl.innerHTML = sideLine('Both sides:', v.spokes, merged);
} else {
buyEl.innerHTML = sideLine('Drive side:', half, sD) + sideLine('Non-drive side:', half, sN);
}
buyEl.hidden = false;
} else {
buyEl.innerHTML = ''; buyEl.hidden = true;
statusEl.classList.remove('is-ready');
if (fatal.length) {
statusEl.textContent = 'No length given: one of the measurements can’t be right.';
} else if (missing.other.length && missing.own.length) {
statusEl.textContent = 'Type this ' + ownWord + '’s figures, then pick the ' + otherWord + ' it is laced to.';
} else if (missing.other.length) {
statusEl.textContent = 'Pick your ' + otherWord + ' above, or type its figures.';
} else {
statusEl.textContent = mode === 'rim' ? 'Type this rim’s ERD to finish.' : 'Type this hub’s figures to finish.';
}
}
warnEl.innerHTML = fatal.map(function (w) { return '<li class="is-fatal">' + w + '</li>'; })
.concat(warnings.map(function (w) { return '<li>' + w + '</li>'; })).join('');
warnEl.hidden = fatal.length + warnings.length === 0;
if (dirty) persist();
}
function persist() {
try {
var data = {
erd: el.erd.value, spacing: el.spacing.value,
pcd_d: el.pcd_d.value, pcd_nd: el.pcd_nd.value,
f2l_d: el.f2l_d.value, f2l_nd: el.f2l_nd.value,
ctf_d: el.ctf_d.value, ctf_nd: el.ctf_nd.value,
spokes: el.spokes.value, cross_d: el.cross.value, cross_nd: 'same',
hole: String(HOLE), offset: '0', offset_dir: 'none',
symmetric: el.symmetric.checked, method: el.method.value
};
localStorage.setItem(STORAGE, JSON.stringify(data));
} catch (e) {}
}
function carryAcross(toMethod) {
var spacing = num('spacing');
if (isNaN(spacing) || spacing <= 0) return;
['d', 'nd'].forEach(function (side) {
var from = toMethod === 'ctf' ? 'f2l_' + side : 'ctf_' + side;
var to = toMethod === 'ctf' ? 'ctf_' + side : 'f2l_' + side;
if (el[to].value !== '') return;
var have = num(from);
if (isNaN(have)) return;
var converted = spacing / 2 - have;
if (converted > 0) el[to].value = String(Math.round(converted * 10) / 10);
});
}
function setSpokes(n) {
var opts = el.spokes.options;
for (var i = 0; i < opts.length; i++) if (Number(opts[i].value) === Number(n)) { el.spokes.value = opts[i].value; return; }
}
function hubFromRow(h) {
// Columns: title, handle, front, pcd left, pcd right, spacing, position left, position right,
// isFlangeToLocknut, holes, spacingGuessed, sidesKnown. When sidesKnown is 1 the right column
// is the drive side. Otherwise it is guessed: hubs come left or right hand drive, so the bigger
// flange is taken as the drive side; with matching flanges, the one the driver pushes closer to
// the centre, except on a disc hub, where the rotor pushes the non-drive flange in instead.
var pl = h[3], pr = h[4], sp = h[5], aL = h[6], aR = h[7], isF2L = h[8];
var driveRight = true;
if (h[11] === 1) driveRight = true;
else if (pl !== pr) driveRight = pr > pl;
else if (aL !== aR) {
var rightCloser = isF2L ? aR > aL : aR < aL;
var disc = /\bdisc\b/i.test(String(h[0]));
driveRight = disc ? !rightCloser : rightCloser;
}
return { pD: driveRight ? pr : pl, pN: driveRight ? pl : pr, aD: driveRight ? aR : aL, aN: driveRight ? aL : aR, sp: sp, isF2L: isF2L, holes: h[9], spGuessed: h[10], front: h[2] };
}
function fillHub(h) {
var x = hubFromRow(h);
filling = true;
el.symmetric.checked = (x.pD === x.pN && x.aD === x.aN);
el.pcd_d.value = x.pD; el.pcd_nd.value = x.pN;
el.method.value = x.isF2L ? 'locknut' : 'ctf';
if (x.isF2L) { el.f2l_d.value = x.aD; el.f2l_nd.value = x.aN; el.ctf_d.value = ''; el.ctf_nd.value = ''; }
else { el.ctf_d.value = x.aD; el.ctf_nd.value = x.aN; el.f2l_d.value = ''; el.f2l_nd.value = ''; }
if (x.sp) el.spacing.value = x.sp;
if (x.holes && x.holes.length === 1) setSpokes(x.holes[0]);
filling = false;
return x;
}
function fillRim(r) {
filling = true;
el.erd.value = r[2];
if (r[3] && r[3].length === 1) setSpokes(r[3][0]);
filling = false;
}
function hubSummary(x) {
var flanges = x.pD === x.pN ? x.pD + ' mm flanges' : x.pD + ' / ' + x.pN + ' mm flanges';
var s = flanges + (x.sp ? ', ' + x.sp + ' mm wide' : '') + (x.holes && x.holes.length ? ', ' + x.holes.join(' or ') + ' hole' : '') + '.';
if (x.spGuessed) s += ' Spacing is not published for it, so the usual ' + x.sp + ' mm is assumed.';
return s;
}
function rimSummary(r) {
return 'ERD ' + r[2] + ' mm' + (r[3] && r[3].length ? ', ' + r[3].join(' or ') + ' hole' : '') + '.';
}
function setOwnMissing() {
ownSummary.textContent = 'We don’t have its measurements on file yet. Type them in below.';
ownSummary.classList.add('is-missing');
if (ownToggle) ownToggle.textContent = 'Type its figures';
if (ownDetails) ownDetails.open = true;
}
function tagOf(row) {
return otherWord === 'rim' ? (row[2] ? row[2] + ' mm' : '') : (row[2] ? 'Front' : 'Rear');
}
function initCombo(rows, onPick) {
var box = root.querySelector('[data-combo]');
if (!box) return null;
var input = box.querySelector('input'), list = box.querySelector('ul'), clearBtn = box.querySelector('[data-combo-clear]');
var idBase = list.id + '-';
var items = rows.map(function (row, i) {
return { i: i, row: row, name: String(row[0]), key: String(row[0]).toLowerCase(), tag: tagOf(row) };
}).sort(function (a, c) { return a.key < c.key ? -1 : (a.key > c.key ? 1 : 0); });
var shown = [], active = -1, selected = null;
function filter(q) {
var t = q.toLowerCase().split(/\s+/).filter(Boolean);
return items.filter(function (it) {
for (var k = 0; k < t.length; k++) { if (it.key.indexOf(t[k]) === -1) return false; }
return true;
});
}
function render(q) {
shown = filter(q); active = -1;
var html = '';
if (!shown.length) {
html = '<li class="lux-mini__opt-empty" role="presentation">Nothing matching “' + esc(q) + '”. Type its figures below.</li>';
} else {
shown.forEach(function (it, n) {
html += '<li role="option" id="' + idBase + it.i + '" data-n="' + n + '" aria-selected="' + (selected === it ? 'true' : 'false') + '"><span>' + esc(it.name) + '</span>' + (it.tag ? '<span class="lux-mini__opt-tag">' + esc(it.tag) + '</span>' : '') + '</li>';
});
}
list.innerHTML = html;
}
function open() { render(input.value); list.hidden = false; input.setAttribute('aria-expanded', 'true'); }
function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
function setActive(n) {
var lis = list.querySelectorAll('li[role="option"]');
if (!lis.length) return;
if (n < 0) n = lis.length - 1;
if (n >= lis.length) n = 0;
Array.prototype.forEach.call(lis, function (li) { li.classList.remove('is-active'); });
active = n;
lis[n].classList.add('is-active');
input.setAttribute('aria-activedescendant', lis[n].id);
if (lis[n].scrollIntoView) lis[n].scrollIntoView({ block: 'nearest' });
}
function choose(n) {
var it = shown[n];
if (!it) return;
selected = it;
input.value = it.name;
box.classList.add('has-value');
close();
onPick(it.row);
}
function reset() { selected = null; input.value = ''; box.classList.remove('has-value'); close(); }
input.addEventListener('focus', open);
input.addEventListener('click', function () { if (list.hidden) open(); });
input.addEventListener('input', function () {
if (selected && input.value !== selected.name) { selected = null; box.classList.remove('has-value'); pickedEl.hidden = true; }
open();
});
input.addEventListener('keydown', function (e) {
if (e.key === 'ArrowDown') { if (list.hidden) open(); setActive(active + 1); e.preventDefault(); }
else if (e.key === 'ArrowUp') { if (list.hidden) open(); setActive(active - 1); e.preventDefault(); }
else if (e.key === 'Enter') {
if (!list.hidden && active >= 0) { choose(active); e.preventDefault(); }
else if (!list.hidden && shown.length === 1) { choose(0); e.preventDefault(); }
else e.preventDefault();
}
else if (e.key === 'Escape' || e.key === 'Esc') { if (!list.hidden) { close(); e.stopPropagation(); } }
else if (e.key === 'Tab') { close(); }
});
list.addEventListener('mousedown', function (e) { e.preventDefault(); });
list.addEventListener('click', function (e) {
var li = e.target.closest ? e.target.closest('li[role="option"]') : null;
if (li) choose(Number(li.dataset.n));
});
clearBtn.addEventListener('click', function () { reset(); pickedEl.hidden = true; input.focus(); });
document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
return { reset: reset };
}
function pickedNote(row, extra) {
var handle = row[1] || slugOf(row[0]);
pickedEl.innerHTML = 'Filled in from <a href="/products/' + esc(handle) + '">' + esc(row[0]) + '</a>.' + (extra ? ' ' + extra : '');
pickedEl.classList.toggle('is-warn', !!extra);
pickedEl.hidden = false;
}
function buildFromData(data) {
if (!data || !data.r || !data.h) return;
var handle = root.dataset.handle || '';
var ownRows = mode === 'rim' ? data.r : data.h;
var otherRows = mode === 'rim' ? data.h : data.r;
var own = null;
for (var i = 0; i < ownRows.length; i++) {
var row = ownRows[i];
if ((row[1] && row[1] === handle) || slugOf(row[0]) === handle) { own = row; break; }
}
if (own) {
if (mode === 'rim') { fillRim(own); ownSummary.textContent = rimSummary(own); }
else { var x = fillHub(own); ownSummary.textContent = hubSummary(x); }
ownSummary.classList.remove('is-missing');
} else {
setOwnMissing();
}
combo = initCombo(otherRows, function (row) {
if (mode === 'rim') {
var x = fillHub(row);
pickedNote(row, x.spGuessed ? 'Its spacing is not published, so the usual ' + x.sp + ' mm is assumed. Check yours.' : '');
} else {
fillRim(row);
pickedNote(row, '');
}
dirty = true;
update();
});
update();
}
function loadWheelData() {
if (!PICK_URL) { setOwnMissing(); return; }
var cached = null;
try { cached = JSON.parse(sessionStorage.getItem(PICK_CACHE) || 'null'); } catch (e) {}
if (cached) { try { buildFromData(cached); } catch (err) { warn('wheel data', err); } return; }
if (typeof fetch !== 'function') { setOwnMissing(); return; }
fetch(PICK_URL, { credentials: 'same-origin' })
.then(function (res) { if (!res.ok) throw new Error('http ' + res.status); return res.text(); })
.then(function (html) {
var doc = new DOMParser().parseFromString(html, 'text/html');
var tag = doc.getElementById('lux-wheel-data');
if (!tag) throw new Error('no data block');
var data = JSON.parse(tag.textContent);
try { sessionStorage.setItem(PICK_CACHE, JSON.stringify(data)); } catch (e) {}
buildFromData(data);
})
.catch(function (err) { warn('wheel data', err); setOwnMissing(); });
}
function touched(e) { return !filling && !(e.target && e.target.getAttribute && e.target.getAttribute('role') === 'combobox'); }
form.addEventListener('input', function (e) { if (touched(e)) dirty = true; update(); });
form.addEventListener('change', function (e) { if (touched(e)) dirty = true; update(); });
form.addEventListener('submit', function (e) { e.preventDefault(); update(); });
Array.prototype.forEach.call(el.method, function (radio) {
radio.addEventListener('change', function () { if (radio.checked) carryAcross(radio.value); });
});
['erd', 'spacing', 'pcd_d', 'pcd_nd', 'f2l_d', 'f2l_nd', 'ctf_d', 'ctf_nd'].forEach(function (k) {
var isOther = mode === 'rim' ? k !== 'erd' : k === 'erd';
el[k].addEventListener('input', function () {
if (filling || !isOther) return;
if (combo) combo.reset();
pickedEl.hidden = true;
});
});
update();
var loaded = false;
function loadOnce() { if (loaded) return; loaded = true; loadWheelData(); }
// Inside an accordion the row starts collapsed, so load when it is opened as well as when it scrolls into view.
var row = root.closest ? root.closest('accordion-element') : null;
if (row) {
row.addEventListener('click', function () { setTimeout(loadOnce, 0); });
row.addEventListener('focusin', loadOnce);
}
if (window.IntersectionObserver) {
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (e) { if (e.isIntersecting && e.boundingClientRect.height > 0) { io.disconnect(); loadOnce(); } });
});
io.observe(root);
} else {
loadOnce();
}
}
function initAll(scope) {
var nodes = (scope && scope.querySelectorAll ? scope : document).querySelectorAll('[data-lux-spoke-mini]');
Array.prototype.forEach.call(nodes, initMini);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
else initAll(document);
document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
